<svg
  height="1em"
  width="1em"
  viewBox="0 0 422 281"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="140.5" cy="140.5" r="140.5" fill="currentColor" />
  <path
    d="M355 128H397V87H422V193H397V150H355V193H330V87H355V128Z"
    fill="currentColor"
  />
</svg>
